import Vue from 'vue';
import Vuetify from 'vuetify';
import 'vuetify/dist/vuetify.min.css';
import '@mdi/font/css/materialdesignicons.css';

Vue.use(Vuetify);

const opts = {
	theme: {
		themes: {
			light: {
				primary: '#003366',
				primaryOpacity25: '#BFCCD9',
				secondary: '#EF4142',
				secondaryOpacity25: '#FBCFD0',
				secondaryOpacity10: '#FDECEC',
				statusGreen: '#52B498',
				statusGreenOpacity25: '#D1E9E3',
				statusRed: '#EF4142',
				statusRedOpacity25: '#FBD0D0',
				statusYellow: '#DFA204',
				statusYellowOpacity25: '#F7E8C0',
				shadowBlue: '#003366',
				shadowBlueOpacity25: '#E3F2FF',
				brandBlack65: '#757575'
			}
		}
	}
};

export default new Vuetify(opts);